export class ConfigProps {

    static UPDATE_IS_PER_CELL_W = "UPDATE_IS_PER_CELL_W"
    static UPDATE_KPI_PER_CELL_W = "UPDATE_KPI_PER_CELL_W"
    static UPDATE_OTHER_PER_CELL_W = "UPDATE_OTHER_PER_CELL_W"
    static MD_UPDATE_SCALE = "MD_UPDATE_SCALE"

    static VC_IS_PER_CELL_W = "VC_IS_PER_CELL_W"
    static VC_KPI_PER_CELL_W = "VC_KPI_PER_CELL_W"
    static VC_OTHER_PER_CELL_W = "VC_OTHER_PER_CELL_W"

    static CD_IS_PER_CELL_W = "CD_IS_PER_CELL_W"
    static CD_KPI_PER_CELL_W = "CD_KPI_PER_CELL_W"
    static CD_OTHER_PER_CELL_W = "CD_OTHER_PER_CELL_W"

    static FC_IS_PER_CELL_W = "FC_IS_PER_CELL_W"
    static FC_KPI_PER_CELL_W = "FC_KPI_PER_CELL_W"
    static FC_OTHER_PER_CELL_W = "FC_OTHER_PER_CELL_W"

    static TABLE_TYPES = "tableTypes"

    static T_MISTAKES_FOR_R_UPDATE = "maxMistakesForReqularUpdate"
    static T_MISTAKES_FOR_F_C_REVIEW = "maxMistakesForFullCheckReview"
    static T_MISTAKES_FOR_C_D_C_REVIEW = "maxMistakesForCoreDataCheckReview"
}

export const DEFAULT_CONFIG = {
    [ConfigProps.UPDATE_IS_PER_CELL_W]: 0.461,
    [ConfigProps.UPDATE_KPI_PER_CELL_W]: 1.404,
    [ConfigProps.UPDATE_OTHER_PER_CELL_W]: 0.461,
    [ConfigProps.MD_UPDATE_SCALE]: 0.9,


    [ConfigProps.VC_IS_PER_CELL_W]: 0.18,
    [ConfigProps.VC_KPI_PER_CELL_W]: 0.306,
    [ConfigProps.VC_OTHER_PER_CELL_W]: 0.18,


    [ConfigProps.CD_IS_PER_CELL_W]: 0.429,
    [ConfigProps.CD_KPI_PER_CELL_W]: 1.275,
    [ConfigProps.CD_OTHER_PER_CELL_W]: 0.429,


    [ConfigProps.FC_IS_PER_CELL_W]: 0.212,
    [ConfigProps.FC_KPI_PER_CELL_W]: 1.315,
    [ConfigProps.FC_OTHER_PER_CELL_W]: 0.212,


    [ConfigProps.T_MISTAKES_FOR_R_UPDATE]: 1.31,
    [ConfigProps.T_MISTAKES_FOR_F_C_REVIEW]: 1.02,
    [ConfigProps.T_MISTAKES_FOR_C_D_C_REVIEW]: 0.64,


    [ConfigProps.TABLE_TYPES]: []
}

/**
 * Based on weights on (Sept. 2024) we assume that 1 updated cell is equal to 0.2244 verified in a core data review
 */
export const CD_REVIEW_WEIGHT = 0.2244;